import { useQuery } from 'react-query';
import { getCounties } from '../data';

export const useCountiesQuery = () => {
  return useQuery('counties', getCounties, {
    refetchOnWindowFocus: false,
    staleTime: 2 * 60 * 1000,
  });
};
